import React from 'react'
import AntdSwitch from 'antd/es/switch'
import BaseField from './BaseField'
import './FieldBool.scss'


export default function FieldBool(props) {
  /* Input Text
   * Expected Props:
   * className = <string> Optional
   * label = <string> Required
   * value = <string> Required
   * valid = <boolean> Optional
   * validMessage = <string> Optional
   * invalidMessage = <string> Optional
   * help = <string> Optional
   * helpAboveInput = <boolean> Optional
   * onChange = <function()> Required
   * loading = <boolean> Optional
   * disabled = <boolean> Optional
   * readOnly = <boolean> Optional
   * horizontal = <boolean> Optional
   * horizontalLabelSize = <int [1-23]> Optional (Default = 6)
   */

  const onChange = (nextValue) =>
    !props.readOnly
      ? props.onChange({ target: { value: nextValue } })
      : undefined

  // RENDER
  const inputSwitch = (
    <AntdSwitch
      checked={props.value}
      onChange={onChange}
      loading={props.loading}
      disabled={props.disabled || props.readOnly}
    />
  )

  const input = (
    <div className={`form-control field-bool custom-field-input${props?.centered ? ' justify-content-center' : ''}`}>
      {props.text ? (
        <label className="form-check-label custom-field-label">
          {inputSwitch} {props.text}
        </label>
      ) : inputSwitch}
    </div>
  )

  return (
    <BaseField
      className={props.className}
      labelClassName={props.labelClassName}
      inputClassName={props.inputClassName}
      label={props.label}
      input={input}
      disabled={props.disabled}
      readOnly={props.readOnly}
      valid={props.valid}
      validMessage={props.validMessage}
      invalidMessage={props.invalidMessage}
      help={props.help}
      helpAboveInput={props.helpAboveInput}
      horizontal={props.horizontal}
      horizontalLabelSize={props.horizontalLabelSize}
    />
  )
}
